import {useState, useEffect} from 'react';
import {Grid, Button, CircularProgress} from '@mui/material';

import VieworderActionImpl from '../vieworder/VieworderActionImpl';
import { useDispatch, useSelector } from 'react-redux';
import { updatePharmaorderObj } from 'store/slice/PharmaSlice';
import { submitOrderForApprovalAPI } from 'api/OrderServicesExtn';
import ErrorMessage from 'core/components/ErrorMessage';
import SuccessMessage from 'core/components/SuccessMessage';
import { useNavigate } from "react-router-dom";
import { addInfo } from 'store/slice/HeaderSlice';
import { updateProductObj } from 'store/slice/PharmaSlice';
import { setPharmaorderSubmitorderModal } from 'store/slice/PharmaSlice';
import { setInfoMsg } from 'store/slice/AppSlice';

export default function SubmitorderActionImpl(){
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [apiInProgress, setApiInProgress] = useState(false);
    const {pharmaorderObj} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard)

    const orderSubmitSuccess = (response)=>{
        dispatch(addInfo({
            id:'001',
            value:response.pharmaorderInfo.id
        }))
        setApiInProgress(false);

        if (response.productInfoList!=null){
            response.productInfoList.list.map(productObj=> dispatch(updateProductObj(productObj)))
        }
        setSuccessMsg("Order '"+response.pharmaorderInfo.id+"' is submitted for approval !!!");
        dispatch(updatePharmaorderObj(response.pharmaorderInfo));
        dispatch(setPharmaorderSubmitorderModal(false));
    
    }
    const orderSubmitFailure = (apiErrMsg)=>{
        setApiInProgress(false);
        setErrMsg(apiErrMsg);
        
    }
    const handleOrderSubmit = () =>{
        //setSuccessMsg("Order  is submitted for approval !!!");
        setErrMsg('')
        dispatch(setInfoMsg("Order is submitted for approval !!!"));
        setApiInProgress(true);
        
        submitOrderForApprovalAPI({   
            orderId:pharmaorderObj.id
            }, orderSubmitSuccess, orderSubmitFailure
        )
    }
    const getComponent = () =>{
        if (apiInProgress) return <CircularProgress/>
        if (successMsg!=='') return <Grid item align="right"  padding={1}><SuccessMessage message={successMsg} /></Grid>

        return <Grid item lg={4} xs={4} align="right"><Button variant="contained" onClick={()=>handleOrderSubmit()}>Submit</Button></Grid>
    }
    return (
        <>
        <VieworderActionImpl/>

        <Grid container direction="row" sx={{justifyContent: "space-between",alignItems: "center"}} padding={1}>
            <Grid item lg={8} xs={8} >
                <ErrorMessage  message={errMsg}/>
            </Grid>
            
            {getComponent()}
            
            
        </Grid>
        </>
    )
}